import { useFlow } from "@contentstech/stackflow-solid/future";
import { Button as RawButton } from "@kobalte/core/button";
import { Suspense, createSignal } from "solid-js";
import { Temporal } from "temporal-polyfill";
import PayoutReadyImage from "~/assets/payout-ready-popup.png";
import { Dialog, DialogContent, DialogFooter } from "./ui/dialog";
import { Image } from "./ui/image";
import { Skeleton } from "./ui/skeleton";

const HIDE_PAYOUT_BANNER_UNTIL_DATE_KEY = "backpac-payout-banner-shown";
export const NOW = Temporal.Now.zonedDateTimeISO("America/Los_Angeles");

class PayoutReadyPopUpStatus {
  public get isShowPopup() {
    if (NOW.day < 25) return false;

    const storedDate = localStorage.getItem(HIDE_PAYOUT_BANNER_UNTIL_DATE_KEY);
    if (!storedDate) return true;

    try {
      const lastShownDate = Temporal.PlainDate.from(storedDate);
      const currentDate = NOW.toPlainDate();
      const daysSinceLastShown = currentDate.since(lastShownDate).days;
      return daysSinceLastShown >= 7;
    } catch (e) {
      console.error(e);
      return true;
    }
  }

  public setPopupHidden() {
    localStorage.setItem(
      HIDE_PAYOUT_BANNER_UNTIL_DATE_KEY,
      Temporal.Now.zonedDateTimeISO("America/Los_Angeles").toPlainDate().toString(),
    );
  }
}

export const payoutPopupStatus = new PayoutReadyPopUpStatus();

export const PayoutReadyPopup = () => {
  const [isShowPopup, setIsShowPopup] = createSignal(payoutPopupStatus.isShowPopup);
  const actions = useFlow();

  return (
    <Dialog open={isShowPopup()}>
      <DialogContent class="p-0! gap-0! rounded-none!">
        <Suspense fallback={<Skeleton width="320px" height="380px" />}>
          {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
          <div
            onClick={() => {
              actions.push("PayoutActivity", {});
              setIsShowPopup(false);
            }}
          >
            <Image src={PayoutReadyImage} alt="Promotion Banner" width={320} />
          </div>
        </Suspense>
        <DialogFooter class="flex h-48px mt-0! flex-row! p-16px justify-between!">
          <RawButton
            class="flex items-center gap-4px"
            onClick={() => {
              payoutPopupStatus.setPopupHidden();
              setIsShowPopup(false);
            }}
            tabIndex={-1}
          >
            <i class="inline-block i-bp-check size-12px" />
            <span class="prose-xs text-primary">Don't show again for 7 days</span>
          </RawButton>
          <RawButton
            class="flex items-center gap-4px focus-outline-none"
            onClick={() => {
              setIsShowPopup(false);
            }}
          >
            <span class="prose-xs text-primary">OK</span>
          </RawButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
